import ActualizarDatos from './hdi/datos/ActualizarDatos.svelte';
import CambiarContrasena from './hdi/datos/CambiarContrasena.svelte';
import SeguimientoReparacion from './hdi/siniestros/SeguimientoReparacion.svelte';
import ConsultarRadicado from './hdi/siniestros/ConsultarRadicado.svelte';
import ReportarSiniestroVehiculo from './hdi/siniestros/vehiculo/ReportarSiniestroVehiculo.svelte';
import VehiculoCompletarSearch from './hdi/siniestros/vehiculo/completar/VehiculoComplementarSearch.svelte';
import VehiculoCompletarDetails from './hdi/siniestros/vehiculo/completar/VehiculoComplementarDetails.svelte';
import ReparacionEncuesta from "./hdi/siniestros/vehiculo/encuesta/ReparacionEncuesta.svelte";
import DescargarCertificado from './hdi/certificados/DescargarCertificado.svelte';
import Producto from './hdi/productos/Producto.svelte';
import PagosDisponibles from "./hdi/pagos/PagosDisponibles.svelte";
import PagosHistorico from "./hdi/pagos/PagosHistorico.svelte";
import PagosCertificacion from "./hdi/pagos/PagosCertificacion.svelte";
import PagoDetalles from "./hdi/pagos/PagoDetalles.svelte";
import PagosFormasDisponibles from "./hdi/pagos/PagosFormasDisponibles.svelte";
import PagoApp from "./hdi/pagos/PagoApp.svelte";
import PagosCart from "./hdi/pagos/PagosCart.svelte";
import Directorio from "./hdi/directorio/Directorio.svelte";
import PrimerIngreso from "./hdi/sesion/PrimerIngreso.svelte";
import { httpRequest } from "./utils";
import DialogMessage from "./hdi/common/DialogMessage.svelte";
export default {
    ActualizarDatos,
    CambiarContrasena,
    SeguimientoReparacion,
    ConsultarRadicado,
    ReportarSiniestroVehiculo,
    VehiculoCompletarSearch,
    VehiculoCompletarDetails,
    DescargarCertificado,
    Producto,
    PagosDisponibles,
    PagosHistorico,
    PagosCertificacion,
    PagoDetalles,
    PagosFormasDisponibles,
    httpRequest,
    Directorio,
    PrimerIngreso,
    ReparacionEncuesta,
    PagoApp,
    PagosCart,
    DialogMessage
};
